export default __webpack_public_path__ + "static/media/157.1896e88c.png";